import {
  Button,
  Flex,
  Modal,
  ScrollArea,
  Textarea,
  TextInput,
} from "@mantine/core";
import { isNotEmpty, useForm } from "@mantine/form";
import { useCallback } from "react";

import { CreateDeskCollectionMessageTemplateInput } from "../../graphql/generated.ts";
import { MessageTemplate } from "../../types/deskCollection/messageTemplate.ts";
import { messageTemplateInstruction } from "./constants.tsx";

interface Props {
  opened: boolean;
  onClose: () => void;
  onSubmit: (value: CreateDeskCollectionMessageTemplateInput) => void;
}

export const MessageTemplateModal = ({ opened, onClose, onSubmit }: Props) => {
  const form = useForm<Pick<MessageTemplate, "name" | "template">>({
    validate: {
      name: isNotEmpty("Field is required"),
      template: isNotEmpty("Field is required"),
    },
    validateInputOnBlur: true,
  });

  const handleClose = useCallback(() => {
    form.reset();
    onClose();
  }, [form, onClose]);

  const handleSubmit = useCallback(() => {
    if (!form.isValid()) {
      return;
    }
    onSubmit(form.values);
    handleClose();
  }, [form, handleClose, onSubmit]);

  return (
    <>
      <Modal
        opened={opened}
        title="Create Prompt"
        closeButtonProps={{
          size: 24,
          iconSize: 24,
        }}
        size="xl"
        scrollAreaComponent={ScrollArea.Autosize}
        onClose={handleClose}
      >
        <Flex direction="column" gap={20}>
          {messageTemplateInstruction}
          <Flex gap={12} direction="column">
            <TextInput
              required
              label="Name"
              placeholder="Enter Name"
              size="m"
              {...form.getInputProps("name")}
            />
            <Textarea
              placeholder="Enter Template"
              autosize
              size="m"
              minRows={3}
              {...form.getInputProps("template")}
            />
          </Flex>
          <Flex gap={20} justify="end">
            <Button
              variant="outlineBlue"
              uppercase
              type="reset"
              onClick={onClose}
            >
              cancel
            </Button>
            <Button
              variant="filledBlue"
              uppercase
              type="submit"
              disabled={!form.isValid()}
              onClick={handleSubmit}
            >
              save
            </Button>
          </Flex>
        </Flex>
      </Modal>
    </>
  );
};
